<script setup lang="ts">
import CoinsFloatingButton from '@qicgroupdoha/loyalty-components/components/CoinsFloatingButton';
import CoinsWheelPopup from '@qicgroupdoha/loyalty-components/components/CoinsWheelPopup';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useRenewQuoteStore } from '@/entities/Stores/RenewQuote';
import { GA_EVENTS, useGoogleAnalytics } from '@/shared/analytics';
import { ProductCode } from '@/shared/constants/Policy';
import { TERMS_CONDITIONS_URL } from '../lib/B2S.contants';
import { useIsB2SActive } from '../model/useIsB2SActive';

const { isB2SActive } = useIsB2SActive();
const gaService = useGoogleAnalytics();
const renewQuoteStore = useRenewQuoteStore();
const route = useRoute();

const isModalOpen = ref(false);
const isRenewPage = computed(() => route.name === 'renew-insurance');

function sendEvent(params: Record<string, unknown>, event: GA_EVENTS) {
  gaService.send(event, {
    popup_name: 'b2s_to_get_more_coins',
    product: 'renewal',
    page: 'renew-insurance',
    ...params,
  });
}

function sendLinkEvent() {
  sendEvent({ link_title: 'terms_and_conditions' }, GA_EVENTS.CLICK_LINK);
}

function handleClose(btnTitle: 'close' | 'lets_go') {
  isModalOpen.value = false;
  sendEvent({ button_title: btnTitle }, GA_EVENTS.CLICK_BTN);
}

function handleOpen() {
  isModalOpen.value = true;
  sendEvent(
    {
      popup_name: undefined,
      page: 'your_quote',
      icon_title: 'b2s_logo',
      plan_name: renewQuoteStore.selectedScheme?.productcode === ProductCode.TPL ? 'TPL' : 'OD',
      policy_id: renewQuoteStore.details?.policyNumber,
      quote_id: renewQuoteStore.quoteNumber,
    },
    GA_EVENTS.CLICK_ICON,
  );
  sendEvent({}, GA_EVENTS.VIEW_POPUP);
}
</script>

<template>
  <div v-if="isB2SActive && isRenewPage">
    <CoinsFloatingButton class="b2s-floating-button" @click.prevent="handleOpen" />
    <CoinsWheelPopup
      :is-open="isModalOpen"
      :title="$t('renew.b2s_2025.popup.header')"
      :subtitle="$t('renew.b2s_2025.popup.text')"
      :button-text="$t('renew.b2s_2025.popup.button')"
      :footnote-text="$t('renew.b2s_2025.popup.learn_more_about')"
      :footnote-link-text="$t('qic.checkout.terms-link')"
      :footnote-link-url="TERMS_CONDITIONS_URL"
      @close="() => handleClose('close')"
      @lets-go="() => handleClose('lets_go')"
      @link-click="sendLinkEvent"
    />
  </div>
</template>

<style lang="scss">
@use '@styles/utils' as *;

.b2s-floating-button.coins-floating-button {
  position: fixed;
  top: 80px;
  right: 48px;
  z-index: 2;

  @include media-md {
    right: 16px;
  }
}
</style>
